import { Switch as SwitchMantine, type SwitchProps } from '@mantine/core'
import { forwardRef } from 'react'

export const Switch = forwardRef<HTMLInputElement, SwitchProps>((props, ref) => <SwitchMantine {...props} ref={ref} />)

Switch.displayName = 'Switch'
